import { createContext } from 'react'

export let ClientNameContext = createContext<string | undefined>(undefined)
